import React from 'react';
import {
  Edit,
  SimpleForm,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  Toolbar,
  SaveButton,
  DisabledInput,
  BooleanInput,
} from 'react-admin';

const TagToolbar = props => {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
};

const TagEdit = props => {
  return (
    <Edit {...props}>
      <SimpleForm redirect="list" toolbar={<TagToolbar />}>
        <DisabledInput label="ID" source="id" />
        <DisabledInput label="Name" source="name" />
        <ReferenceArrayInput label="Objectives" source="objective_ids" reference="objectives">
          <AutocompleteArrayInput optionText="name" />
        </ReferenceArrayInput>
        <BooleanInput source="edit_similar" label="Edit tags with similar names" />
      </SimpleForm>
    </Edit>
  );
};

export default TagEdit;



// WEBPACK FOOTER //
// ./src/resources/tags/TagEdit.jsx